import React, { useEffect, useState } from "react";
import img from "../../../../assets/img/Home/cover-img (2).png";
import gallery from "../../../../assets/img/admin/gallery-edit.svg";
import Button from "../../../shared/Button";
import useFetch from "../../../../hooks/useAxios";
import toast from "react-hot-toast";
import BeatLoader from "react-spinners/BeatLoader";
const AdminCatCard = ({ info,apicateList }) => {
  console.log(info);
  const [File, setFile] = useState();
  const handleImageChange = e => {
    e.preventDefault();
    let reader = new FileReader();
    let file = e.target.files[0];

    const formData = new FormData();
    formData.append("image", file);
    setFile(formData);
    reader.readAsDataURL(file);
  };

  const apicatepost = useFetch({
    method: "post",
    url: `api/admin/categories/update/${info.name}`,
    noHeader: false,
    trigger: false,
    data: File,
    caller:apicateList,
    argFunc: res => toast.success("تغییر با موفقیت انجام شد"),
    errMessage:res=> toast.error("تغییر با شکست مواجه شد"),
  });
  useEffect(
    () => {
      if (File) {
        apicatepost.reFetch();
      }
    },
    [File]
  );
  return (
    <div className="AdminCatCard">
      <img src={info.image?.path} className="AdminCatCard__thumbnail" />
      <h6>
        {info.title}
      </h6>
      <div className="UploadProfile--uploadcoverbox">
        <input
          type="file"
          className="UploadProfile__input "
          id={info.id}
          onInput={handleImageChange}
          onFocus={e => (e.target.placeholder = "")}

          // defaultValue={convertToFile()}
        />
        <label
          className="UploadProfile__label"
          htmlFor={info.id ? info.id : "image__cover--perview"}
        >
          <div className="button button__borderbot">
            {!apicatepost.loading
              ? <div className="flex gap-[8px]">
                  <img src={gallery} />
                  <div>تغیر عکس نمایه</div>
                </div>
              : <BeatLoader
                  color="#36d7b7"
                  size={10}
                  aria-label="Loading Spinner"
                  data-testid="loader"
                />}
          </div>
        </label>
      </div>
    </div>
  );
};

export default AdminCatCard;
